module.exports = __webpack_public_path__ + "static/img/advance01.286b3ec5.png";